import React, { FC, useMemo, useCallback, memo, useState, useEffect } from 'react';
import { OverlayView } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import {
  IOrder,
  OrderStatus,
  useOrdersActions,
  useOrdersState,
} from '@pages/Deliveries/context/orders';
import {
  useCouriersState,
} from '@pages/Deliveries/context/couriers';
import unassignedMapMarkerImage from '@assets/unassigned-order-map-marker.svg';
import deliveredMapMarkerImage from '@assets/delivered-order-map-marker.svg';
import assignedMapMarkerImage from '@assets/assigned-order-map-marker.svg';
import inDeliveryMapMarkerImage from '@assets/indelivery-order-map-marker.svg';
import useStyles from './styles';
import { parseGuestName } from '@src/shared/utils';
import { useAccordionState } from '@src/shared/context/accordion';
import { Typography } from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '@src/shared/components/JetFontIcon';
import { DrawerType, useInsideDrawerActions } from '@src/shared/context/inside-drawer';
import VehicleTypeIcon from '../VehicleTypeIcon';

interface componentProps{
  sequenceNumber? : Number | null
}
const OrderMarker: FC<IOrder & componentProps > = ({
  reference,
  location,
  courier,
  status,
  uuid,
  customer,
  sequenceNumber = null
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { couriersById } = useCouriersState();
  const { hoveredOrderReference } = useAccordionState();
  const typographyVariant = 'caption'
  const position = useMemo(() => {
    return { lat: location?.latitude, lng: location?.longitude };
  }, [location]);
  const { setClickedOrderId } = useOrdersActions();
  const { setActiveInsideDrawer } = useInsideDrawerActions();


  const offsetHandler = useCallback(
    (_, offsetHeight) => ({
      x: -11,
      y: 11 - offsetHeight,
    }),
    []
  );

  const { setSelectedOrderId } = useOrdersActions();
  const {selectedOrderId} = useOrdersState();

  const getOrderStatusTag = (orderStatus: OrderStatus) => {
    if (orderStatus === undefined) {
      return OrderStatus.Unassigned;
    }
    return orderStatus;
  };



  const handleDrawerState = (orderId: string) => {
    setActiveInsideDrawer(DrawerType.ORDER_CARD);
    setClickedOrderId(orderId)
  }
  
  const markerImages = {
    [OrderStatus.Unassigned]: unassignedMapMarkerImage,
    [OrderStatus.Assigned]: assignedMapMarkerImage,
    [OrderStatus.AssignedToNextPool]: assignedMapMarkerImage,
    [OrderStatus.InDelivery]: inDeliveryMapMarkerImage,
    [OrderStatus.Delivered]: deliveredMapMarkerImage
  }

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={offsetHandler}
    >
      <div
        className={`${classes.boxWrapper} ${courier ? 'courier-assigned' : ''} ${status !== OrderStatus.Delivered ? 'z-layer-top' : ''} ${
          selectedOrderId === uuid || hoveredOrderReference === uuid ? 'z-layer-toppest' : ''
        }`}
      >
        <div
          className={`order-status-${status} ${classes.box} ${
            selectedOrderId === uuid || hoveredOrderReference === uuid ? 'order-hovered' : ''
          }`}

          onClick={() => {/*handleDrawerState(uuid);*/setSelectedOrderId(uuid)}}
        >
          <div className={classes.boxMarkerText}>
            <Typography variant={typographyVariant} className={`${classes.customerName} ${classes.justify_center} ${typographyVariant === 'caption' ? 'caption_bold' : 'body_small_bold'}`} >
              {status !== OrderStatus.Delivered && <>
                {!sequenceNumber && <JetFontIcon iconname={JET_FONTICON_ALIASES.USER_HIGHLIGHT_SMALL} />}
                {sequenceNumber && <span className={classes.sequenceNumber}>{sequenceNumber}</span>}
                {customer?.lastName}
              </>}
              {status === OrderStatus.Delivered && <>
                {customer?.lastName} 
              </>}
            </Typography>
            <div className='separator'></div>
            {status === OrderStatus.Unassigned && <Typography variant={typographyVariant} className={`${typographyVariant === 'caption' ? 'caption' : 'body_small_regular'}`}>{t(`order.status_${getOrderStatusTag(status)}`)}</Typography>}
            {status === OrderStatus.Delivered && <Typography variant={typographyVariant} className={`${classes.justify_center}`} > <JetFontIcon iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE} ></JetFontIcon> {t(`order.status_${getOrderStatusTag(status)}`)}</Typography>}
            {courier && status !== OrderStatus.Unassigned && status !== OrderStatus.Delivered && <Typography  variant={typographyVariant} className={`${classes.customerName} caption`} >
              <VehicleTypeIcon
                    iconType="BADGE"
                    iconSize={12}
                    vehicleType={couriersById[courier?.id]?.vehicleType} />
              {couriersById[courier?.id]?.isGuest ? parseGuestName(couriersById[courier?.id]?.firstName) || couriersById[courier?.id]?.lastName : couriersById[courier?.id]?.firstName}

            </Typography>}
          </div>
        </div>
        <img src={markerImages[status]} className="marker" alt="marker" />
      </div>
    </OverlayView>
  );
};

export default memo(OrderMarker);


